export default __webpack_public_path__ + "4e371a512d8e9ea99ca603e2fd260fe4.png";